import React from 'react';
import Layout from '../UI/modules/visit-form/Layout';

const VisitForm = () => {
  return (
    <Layout />
  );
};

export default VisitForm;
